import { render, staticRenderFns } from "./DigitalDelivery.vue?vue&type=template&id=6c607813&"
import script from "./DigitalDelivery.vue?vue&type=script&lang=ts&"
export * from "./DigitalDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./DigitalDelivery.vue?vue&type=style&index=0&id=6c607813&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports